import { render } from "./NotImplemented.vue?vue&type=template&id=ca30d186"
import script from "./NotImplemented.vue?vue&type=script&lang=js"
export * from "./NotImplemented.vue?vue&type=script&lang=js"
script.render = render

export default script